import React from 'react';
import Navbar from '../components/nav/Navbar';
import Footer from '../components/nav/Footer';

const HelpCenter = () => {
  return (
    <div className="min-h-screen flex flex-col bg-zinc-950 text-zinc-100">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto w-full px-8 py-24 space-y-12 relative z-10">
        <div className="space-y-4">
          <span className="text-xs font-black tracking-widest text-brand-pink uppercase">Support</span>
          <h1 className="text-5xl font-black tracking-tighter text-white uppercase">Help Center</h1>
        </div>
        
        <div className="space-y-8 text-zinc-300 text-lg leading-relaxed">
          <div className="glass-card p-8 rounded-2xl space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">How it works</h2>
            <p>
              Vision Direct connects fans directly with their favorite artists. Support creators by purchasing exclusive drops, joining subscription tiers, and accessing premium content.
            </p>
          </div>

          <div className="glass-card p-8 rounded-2xl space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">Managing Purchases</h2>
            <p>
              All your unlocked drops and active subscriptions can be found in your Vault. From there, you can stream content, download assets, and manage your billing settings.
            </p>
          </div>

          <div className="glass-card p-8 rounded-2xl space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">Contact Support</h2>
            <p>
              Having issues with a transaction or accessing your content? Our team is here to help. Reach out to us at <a href="mailto:support@visionmedia345.com" className="text-brand-coral hover:underline">support@visionmedia345.com</a>.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HelpCenter;